import { activateUser } from '@infuse/api/iam/user';
import { useGenericActivateUser } from './generic/useGenericActivateUser';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { UserLevel } from '@infuse/iam/user/type';
import { activateOrganisationUser } from '@infuse/api/iam/organisation';
import { activateTenantUser } from '@infuse/api/iam/tenant';

export const useActivateUser = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.ORGANISATION) {
    return useGenericActivateUser({
      apiFn: activateOrganisationUser,
      forcedParentId: user?.organisationId
    });
  } else if (level === UserLevel.TENANT) {
    return useGenericActivateUser({
      apiFn: activateTenantUser,
      forcedParentId: user?.tenantId
    });
  }

  return useGenericActivateUser({
    apiFn: activateUser
  });
};
